import { AxiosError } from 'axios'
import { HOME } from 'configs/path'
import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { bindParams } from 'utilities/helpers'
import { getAppSetting } from 'services/appService'
import { APP_ID } from 'configs/constant'

const DefaultRouter = () => {
  const navigate = useNavigate()

  const handleGetAppSetting = async () => {
    try {
      // get APP_ID from localStorage
      const app = localStorage.getItem(APP_ID)
      await getAppSetting({ app_id: app as string })
      if (app) {
        navigate(bindParams(HOME, { app: app }))
      } else {
        navigate('/')
      }
    } catch (error) {
      // check status code != 503
      if (error instanceof AxiosError && error.response?.status !== 503) {
        navigate(bindParams(HOME, { app: '' }))
      }
    }
  }

  useEffect(() => {
    const timeOut = setTimeout(() => {
      handleGetAppSetting()
    }, 100)
    return () => {
      clearTimeout(timeOut)
    }
  }, [])

  return <Outlet />
}

export default DefaultRouter
